import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19.5 21v-4.53a4 4 0 0 0-3.434-3.96L16 12.5a6.074 6.074 0 0 1-8 0l-.066.01A4 4 0 0 0 4.5 16.47V21l8.5-1.5m2-.5 7-11m-6.5-1a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }